import { ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import usePagination from './usePagination'
import { isBoolean, isNumber } from 'lodash'

/**
 *
 * @param {*} apiInterface 列表接口
 * @param {*} queryParams 列表过滤条件
 * @param {*} options 额外配置
 * @returns
 * config.hasChildren 是否有children字段
 * config.hasPagination 是否有分页字段
 */
export default function useBasetable(apiInterface, queryParams, options) {
    console.log('🚀 ~ useBasetable ~ queryParams:', queryParams)
    const config = Object.assign(
        {
            hasChildren: false,
            hasPagination: true
        },
        options
    )
    const total = ref(0)
    const table_data = ref([])
    const tableLoading = ref(false)
    /**
     * 获取列表
     */
    const getTableData = async (callback) => {
        table_data.value = []
        tableLoading.value = true
        try {
            const params = { ...queryParams }
            if (config.hasPagination) {
                params.page = page.value
                params.page_size = page_size.value
                for (const key in params) {
                    if (params[key] === '' || params[key] === null || params[key] === undefined) delete params[key]
                }
                const { lists, total: totalPage } = await apiInterface(params)
                table_data.value = lists
                total.value = totalPage
            } else {
                table_data.value = await apiInterface(params)
            }
            if (config.hasChildren) {
                setRowIndex(table_data.value)
            }
            // 需要单独处理数据 返回Promise
            callback && callback()
            return Promise.resolve(table_data.value)
        } catch (error) {
        } finally {
            tableLoading.value = false
        }
    }
    const setRowIndex = (data) => {
        data.forEach((ele, index) => {
            ele.parentIndex = ele.parentIndex ? ele.parentIndex + '-' + (index + 1) : index + 1
            if (ele.children && ele.children.length > 0) {
                setRowIndex(ele.children)
            }
        })
    }
    /**
     * 获取表格分页数据
     */
    const { handleSizeChange, handleCurrentChange, page, page_size } = config.hasPagination ? usePagination(getTableData, options) : {}
    /**
     * 修改状态
     * @param {*} value // 1 / 0
     * @param  data  当前行数据
     */
    const handleStatus = ({ value, data, api, label = 'status', message }, callback) => {
        if (!data.id) return
        const msg = `是否确认要 ${value ? '启用' : '停用'} ${data.name || '该条数据'} 吗？`
        ElMessageBox.confirm(message || msg, '系统提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
        })
            .then(async () => {
                if (value) {
                    await api('batch_enable', [data.id])
                } else {
                    await api('batch_disable', [data.id])
                }
                ElMessage({
                    type: 'success',
                    message: '操作成功'
                })
                callback && callback()
            })
            .catch(() => {
                if (isNumber(data[label])) {
                    data[label] = value ? 0 : 1
                }
                if (isBoolean(data[label])) {
                    data[label] = !data[label]
                }
            })
    }
    /**
     * 删除 支持批量删除
     * @param {*} data {*} 当前行数据
     * @param {*} callback 删除后的回调
     *
     */

    const onRemoveClick = ({ data, api, fields = 'name' }, callback) => {
        if (!data.length && !Object.keys(data).length) {
            ElMessage.warning('请选择要删除的数据')
            return
        }
        let msg = ''
        let flag = false
        const data_type = Object.prototype.toString.call(data) // [object Array]
        const type = data_type.substring(8, data_type.length - 1)
        if (type === 'Array') {
            msg = '选择的数据'
            flag = data.some((ele) => ele.preset === 1)
        } else if (type === 'Object') {
            msg = data[fields] || '该条数据'
            flag = data?.preset === 1
        }
        if (flag) {
            ElMessage.warning('含有预置数据不允许删除')
            return
        }
        ElMessageBox.confirm('确定要删除 ' + msg + ' 吗？', {
            type: 'warning'
        })
            .then(async () => {
                if (type === 'Array') {
                    await api(
                        'batch_delete',
                        data.map((ele) => ele.id)
                    )
                } else if (type === 'Object') {
                    await api(data.id)
                }
                ElMessage.success('删除成功！')
                if (callback) {
                    callback()
                } else {
                    getTableData()
                }
            })
            .catch((error) => {
                console.error('Confirmation dialog error:', error)
            })
    }
    /**
     * 排序
     * @param {*} api 接口数据
     */
    const onSortClick = async (api) => {
        const soreObj = {}
        if (table_data.value.length === 0) return
        const fn = async (data) => {
            data.forEach((ele) => {
                soreObj[ele.id] = ele.list_order
                if (ele.children) {
                    fn(ele.children)
                }
            })
        }
        await fn(table_data.value)
        try {
            await api('batch_update_order', soreObj)
            ElMessage.success('操作成功')
        } catch (error) {}
        await getTableData()
    }
    /**
     * 导出
     * @param {*} msg 列表名称
     */
    const onExportClick = async (msg, api) => {
        ElMessageBox.confirm(`您确定导出 ${msg} 列表吗？`, {
            type: 'warning'
        })
            .then(async () => {
                const { data } = api
                    ? await api({ ...queryParams.value, export: 1 })
                    : await apiInterface({ ...queryParams.value, export: 1 })
                window.open(data)
                ElMessage.success('导出成功')
            })
            .catch(() => {})
    }
    // 其他批量操作
    const onBatchOperation = ({ data, method, api, fields = 'name', operation = '删除', message }, callback) => {
        if (!data.length && !Object.keys(data).length) {
            ElMessage.warning('请选择要' + operation + '的数据')
            return
        }
        let msg = ''
        const data_type = Object.prototype.toString.call(data) // [object Array]
        const type = data_type.substring(8, data_type.length - 1)
        if (type === 'Array') {
            msg = '选择的数据'
        } else if (type === 'Object') {
            msg = data[fields] || '该条数据'
        }
        const str = '确定要' + operation + msg + ' 吗？'
        ElMessageBox.confirm(message || str, {
            type: 'warning'
        })
            .then(async () => {
                if (method) {
                    if (type === 'Array') {
                        await api(
                            method,
                            data.map((ele) => ele.id)
                        )
                    } else if (type === 'Object') {
                        await api(method, data.id)
                    }
                } else {
                    await api(data.id)
                }
                ElMessage.success(operation + '成功')
                getTableData()
                callback && callback()
            })
            .catch((error) => {
                console.error('Confirmation dialog error:', error)
            })
    }
    return {
        page,
        page_size,
        total,
        table_data,
        tableLoading,
        getTableData,
        handleStatus,
        onRemoveClick,
        handleSizeChange,
        handleCurrentChange,
        onSortClick,
        onExportClick,
        onBatchOperation
    }
}
